import { gql } from '@apollo/client';

export default gql`
  query getExtraProducts(
    $currency: String!
    $segments: [InputSegment!]!
    $passengers: [InputPassenger!]!
    $types: [String!]!
    $isAftersales: Boolean = false
  ) {
    getExtraProducts(currency: $currency, isAftersales: $isAftersales, passengers: $passengers, segments: $segments, types: $types) {
      extras {
        id
        name
        code
        passengerTypes
        passengers
        segments
        price
        paxSegments {
          passengerId
          segments
        }
      }
    }
  }
`;
